import { useState } from 'react';
import { AsyncBoundary } from '@toss/async-boundary';
import { useTranslation } from 'next-i18next';
import { useViewport } from '@/hooks';
import { type TemplateAiTutor } from '@/shared/components/Chatbot';
import { useUpsellingGuard } from '@/shared/plan';
import { DialogBody, DialogHeader, ResponsiveDialog } from '@/ui_v3';
import { AiTutorInstall } from './AiTutorInstall';
import { AiTutorInstallIntro } from './AiTutorInstallIntro';
interface Props {
  initialSelectedAiTutorId?: string;
  mode?: 'install' | 'upsell';
  onConfirmAiTutor?: (aiTutor: TemplateAiTutor) => void;
  onClose?: VoidFunction;
}
export const AiTutorInstallModal = ({
  initialSelectedAiTutorId,
  mode = 'install',
  onConfirmAiTutor,
  onClose
}: Props) => {
  const {
    t
  } = useTranslation(['build']);
  const {
    isMobile
  } = useViewport();
  const [isIntro, setIsIntro] = useState(isMobile && mode === 'install');
  const upsellingGuard = useUpsellingGuard();
  return <ResponsiveDialog
  // ≤560: 바텀시트(풀폭) / 561~767: 중앙 1팬 560 / ≥768: 중앙 2팬 960
  className="max-mobile-lg:!h-[calc(90dvh-env(safe-area-inset-top))] mobile-lg:!h-[670px] mobile-lg:!w-[560px] tablet-sm:!w-[960px]" size="xl" onClose={onClose} data-sentry-element="ResponsiveDialog" data-sentry-component="AiTutorInstallModal" data-sentry-source-file="AiTutorInstallModal.tsx">
      <DialogHeader className="shrink-0" title={t('build:sectionAiTutor.add')} hasCloseButton onClose={onClose} data-sentry-element="DialogHeader" data-sentry-source-file="AiTutorInstallModal.tsx" />
      <DialogBody className="h-auto min-h-0 flex-1 overflow-hidden" data-sentry-element="DialogBody" data-sentry-source-file="AiTutorInstallModal.tsx">
        {isIntro ? <AiTutorInstallIntro onStart={() => {
        upsellingGuard(() => {
          setIsIntro(false);
        }, {
          feature: 'AI_TUTOR',
          from: 'aiTutor'
        });
      }} /> : <AsyncBoundary pendingFallback={null} rejectedFallback={() => null}>
            <AiTutorInstall initialSelectedAiTutorId={initialSelectedAiTutorId} mode={mode} onConfirmAiTutor={onConfirmAiTutor} onClose={onClose} />
          </AsyncBoundary>}
      </DialogBody>
    </ResponsiveDialog>;
};